export default "__VITE_ASSET__CQb3AFCR__"